import script from "./AddBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddBtn.vue?vue&type=script&lang=ts&setup=true"

import "./AddBtn.vue?vue&type=style&index=0&id=7a13aeec&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a13aeec"]])

export default __exports__